export type Environment = 'development' | 'production' | 'staging';

// Can be controlled by Vite's `mode`, currently set when running build commands.
export const env = import.meta.env.MODE as Environment;
